import { useEffect } from 'react';
import { useTranslation } from '../hooks/useTranslation';

const DynamicMetaTags = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // Actualizar título dinámicamente
    document.title = t('meta.title');
    
    // Actualizar meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', t('meta.description'));
    }
    
    // Actualizar Open Graph title
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', t('meta.ogTitle'));
    }
    
    // Actualizar Open Graph description
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', t('meta.ogDescription'));
    }
    
    // Actualizar Twitter title
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', t('meta.twitterTitle'));
    }
    
    // Actualizar Twitter description
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', t('meta.twitterDescription'));
    }
  }, [t]);

  return null; // Este componente no renderiza nada visible
};

export default DynamicMetaTags;